import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { sendEvent, CNPJ_API_URL, LEAD_API_URL } from './Config';
import LoadingSpinner from './components/LoadingSpinner';
import Footer from './components/Footer';

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

function buildChromeIntentUrl(url) {
    try {
        const u = new URL(url);
        const scheme = u.protocol.replace(':', '');
        const fallback = encodeURIComponent(url);
        return `intent://${u.host}${u.pathname}${u.search}${u.hash}#Intent;scheme=${scheme};action=android.intent.action.VIEW;package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
    } catch (e) {
        return url;
    }
}

const ViewPDF = function () {
    const { lead_id } = useParams();
    const leadIdRef = useRef(localStorage.getItem("lead_id"));
    const navigate = useNavigate();
    const leadId = lead_id;
    const [showModal, setShowModal] = useState(1);
    const hasLoadedFirstTime = useRef(false);
    const [nifData, setNIFData] = useState(null);
    const nif = useRef(localStorage.getItem("nif"));

    const pdfUrl = `${LEAD_API_URL}/view/${leadId}`;
    const pdfHref = isAndroid() ? buildChromeIntentUrl(pdfUrl) : pdfUrl;

    async function loadLeadData() {
        if (!leadId) {
            navigate("/");
            return null;
        }

        try {
            const res = await fetch(`${LEAD_API_URL}/onboarding/lead/${leadId}`);

            if (!res.ok) {
                navigate("/");
                return null;
            }

            const json = await res.json();

            if (!json?.documentNumber) {
                navigate("/");
                return null;
            }

            localStorage.setItem("lead_id", leadId);
            localStorage.setItem("cnpj", json.documentNumber);

            if (json?.email) {
                localStorage.setItem("email", json.email);
            }

            return json.documentNumber;
        } catch (e) {
            console.error(e.message);
            navigate("/");
            return null;
        }
    }

    useEffect(() => {
        if (!nif.current) {
            navigate("/")
            return;
        }

        const nifDataStorage = localStorage.getItem(`${nif.current}-data`);


        if (!nifDataStorage) {
            loadNIFData();
        } else {
            setNIFData(JSON.parse(nifDataStorage)[0]);
            setShowModal(0);
        }

        sendEvent(leadIdRef.current ?? false, "email-pdf");
    }, []);

    async function loadNIFData() {
        try {
            const res = await fetch(`${LEAD_API_URL}/onboarding/pt/nif/${nif.current}`);

            if (!res.ok) {
                if (res.status === 429) {
                    throw new Error('Muitas requisições. Tente novamente mais tarde.');
                }

                throw new Error(`Erro HTTP: ${res.status}`);
            }

            const json = await res.json();

            if (json?.length > 0) {
                localStorage.setItem(`${nif.current}-data`, JSON.stringify(json));
                setNIFData(json[0]);
            }
        } catch (e) {
            console.error(e.message);
        } finally {
            setShowModal(0);
        }
    }

    const handleFormSubmit = async (e) => {
        e.preventDefault();
    }

    return <>
        {showModal == 1 ? (<LoadingSpinner />) : ''}
        {showModal == 2 ? (<LoadingSpinner texto={"Gerando a visualização do PDF"} />) : ''}
        <div className={`safari-modal ${showModal == 3 ? 'active' : ''}`}>
            <div id="overlay"></div>

            <div id="popup">
                <div className='text'>
                    <h3>Visualizar PDF</h3>
                    <p>
                        Não é possível abrir o PDF devido às dimensões do documento. Tente acessá-lo em um computador para uma melhor visualização.
                    </p>
                </div>

                <div className="button-holder one-button">
                    <a href="#" className='cancel' onClick={() => setShowModal(0)}>Fechar</a>
                </div>
            </div>
        </div>
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Simulação de crédito BPF</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>Tudo pronto! A simulação do BPF para a sua empresa já está concluída.</h1>
                    <p className='mt-6 separator-bottom pb-5 mb-5'>O resultado da sua simulação encontra-se disponível em formato PDF. Atente nas informações abaixo.</p>
                    <div className='flex flex-col gap-1 separator-bottom pb-5'>
                        <div>NIPC:</div>
                        <strong>{nif.current}</strong>
                        {nifData && <>
                            {nifData.name && <>
                                <div className="pt-1">Denominação Social:</div>
                                <strong>{nifData.name}</strong>
                            </>}
                            {nifData?.geo?.postal_code && <>
                                <div className="pt-1">Endereço:</div>
                                <div className='flex flex-col'>
                                    <strong>{nifData.geo.address}</strong>
                                    <strong>{nifData.geo.postal_code}</strong>
                                </div>
                            </>}
                        </>}
                        <div className="pt-1">Categoria simulada:</div>
                        <strong>De € 500 mil a € 4,5 milhões</strong>
                        <div className="pt-1">Prazo para pagamento:</div>
                        <strong>Até 30 anos</strong>
                    </div>
                    <div className="pt-4 mb-8">Consulte no PDF abaixo as condições e as modalidades de pagamento disponíveis para a sua empresa.</div>
                    <a href={pdfHref} onClick={async (e) => {
                        if (hasLoadedFirstTime.current == 0) {
                            hasLoadedFirstTime.current = 1;
                            setShowModal(2);

                            setTimeout(() => {
                                setShowModal(0);
                            }, 3 * 1000);
                        }

                        localStorage.setItem("utm_source", "");

                        try {
                            await sendEvent(leadId ?? false, isAndroid() ? "view-pdf-android-intent-click" : "view-pdf-desktop-click");
                        } catch (e) {

                        }
                    }} className="primary w-full">
                        Ver PDF
                    </a>
                </div>
            </form>
        </div>
    </>
}

export default ViewPDF;